import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { ExportPriceSheetProps } from 'shared/services';

export function usePriceSheetExport() {
    const { productService } = useService();
    const mutation = useMutation<void, Error, ExportPriceSheetProps>(request =>
        productService.exportPriceSheet(request)
    );
    return mutation;
}
